

// For nosto slider
function openFunction(opener){
  console.log('nosto click work');
}
// nosto end



setTimeout(() => {
  const swipernostoindex = new Swiper('.index .swipernosto', {
   // Optional parameters
    // direction: 'vertical',
    loop: false,
    slidesPerView:5,
    spaceBetween: 40,
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
        "@0.00": {
        slidesPerView: 1.5,
        spaceBetween: 10,
        },
        "@0.75": {
          draggable: true,
          allowTouchMove:false,
        slidesPerView: 2.5,
        spaceBetween: 20,
        },
        "@1.00": {
          draggable: true,
          allowTouchMove:false,
        slidesPerView: 5,
        spaceBetween: 40,
        },
        "@1.50": {
          draggable: true,
          allowTouchMove:false,
        slidesPerView: 5,
        spaceBetween: 40,
        },
    },
    shortSwipes: false,
    simulateTouch: false,
    preventInteractionOnTransition: false,
    preventClicks: false,
    preventClicksPropagation: false,
    allowSwipeToNext: false,
    watchSlidesProgress: true
  });
  const productpageswipernosto = new Swiper('#productpage-nosto-1 .swipernosto', {
    // Optional parameters
    // direction: 'vertical',
    loop: false,
    slidesPerView:5,
    spaceBetween: 40,
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
        "@0.00": {
        slidesPerView: 1.5,
        spaceBetween: 10,
        },
        "@0.75": {
          draggable: true,
          allowTouchMove:false,
        slidesPerView: 2.5,
        spaceBetween: 20,
        },
        "@1.00": {
          draggable: true,
          allowTouchMove:false,
        slidesPerView: 5,
        spaceBetween: 40,
        },
        "@1.50": {
          draggable: true,
          allowTouchMove:false,
        slidesPerView: 5,
        spaceBetween: 40,
        },
    },
    shortSwipes: false,
    simulateTouch: false,
    preventInteractionOnTransition: false,
    preventClicks: false,
    preventClicksPropagation: false,
    allowSwipeToNext: false,
    watchSlidesProgress: true
  });
  const productpageswipernosto2 = new Swiper('#productpage-nosto-2 .swipernosto', {
    // Optional parameters
    // direction: 'vertical',
    loop: false,
    slidesPerView:5,
    spaceBetween: 40,
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
        "@0.00": {
        slidesPerView: 1.5,
        spaceBetween: 10,
        },
        "@0.75": {
          draggable: true,
          allowTouchMove:false,
        slidesPerView: 2.5,
        spaceBetween: 20,
        },
        "@1.00": {
          draggable: true,
          allowTouchMove:false,
        slidesPerView: 5,
        spaceBetween: 40,
        },
        "@1.50": {
          draggable: true,
          allowTouchMove:false,
        slidesPerView: 5,
        spaceBetween: 40,
        },
    },
    shortSwipes: false,
    simulateTouch: false,
    preventInteractionOnTransition: false,
    preventClicks: false,
    preventClicksPropagation: false,
    allowSwipeToNext: false,
    watchSlidesProgress: true
  });
  const swipernosto1 = new Swiper('#categorypage-nosto-1 .swipernosto', {
   // Optional parameters
    // direction: 'vertical',
    loop: false,
    slidesPerView:5,
    spaceBetween: 40,
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
        "@0.00": {
        slidesPerView: 1.5,
        spaceBetween: 10,
        },
        "@0.75": {
          draggable: true,
          allowTouchMove:false,
        slidesPerView: 2.5,
        spaceBetween: 20,
        },
        "@1.00": {
          draggable: true,
          allowTouchMove:false,
        slidesPerView: 5,
        spaceBetween: 40,
        },
        "@1.50": {
          draggable: true,
          allowTouchMove:false,
        slidesPerView: 5,
        spaceBetween: 40,
        },
    },
    shortSwipes: false,
    simulateTouch: false,
    preventInteractionOnTransition: false,
    preventClicks: false,
    preventClicksPropagation: false,
    allowSwipeToNext: false,
    watchSlidesProgress: true
  });  
  const cartpagenosto1 = new Swiper('#cartpage-nosto-1 .swipernosto', {
    loop: false,
    slidesPerView: 5,
    spaceBetween: 40,
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      "@0.00": {
        slidesPerView: 1.5,
        spaceBetween: 10,
      },
      "@0.75": {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      "@1.00": {
        slidesPerView: 5,
        spaceBetween: 40,
      },
      "@1.50": {
        slidesPerView: 5,
        spaceBetween: 40,
      },
    },
    shortSwipes: true,
    simulateTouch: true,
    preventInteractionOnTransition: true,
    preventClicks: true,
    preventClicksPropagation: true,
    allowSwipeToNext: false
  });
  const searchpagenosto1 = new Swiper('#searchpage-nosto-1 .swipernosto', {
    loop: false,
    slidesPerView: 5,
    spaceBetween: 40,
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      "@0.00": {
        slidesPerView: 1.5,
        spaceBetween: 10,
      },
      "@0.75": {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      "@1.00": {
        slidesPerView: 5,
        spaceBetween: 40,
      },
      "@1.50": {
        slidesPerView: 5,
        spaceBetween: 40,
      },
    },
    shortSwipes: true,
    simulateTouch: true,
    preventInteractionOnTransition: true,
    preventClicks: true,
    preventClicksPropagation: true,
    allowSwipeToNext: false
  });
}, 4500)

























// console.log(window.screen.width);
// window.onload = function () {
    if (window.screen.width > 989) {
        [...document.querySelectorAll('.footer-block details')].forEach(function (element) {
            element.setAttribute("open", "");
            // console.log(element);
        });
    }
// };

// Megamenu
function menuHoverd(data) {
    let NextDivId = data;
    // console.log(event.target);
    var myElem = document.querySelector(`#${NextDivId}`);
    if (myElem === null || !myElem) {
        // console.log('Child div not found');
        [...event.target.parentElement.children].forEach(sib => sib.classList.remove('active'));
        [...event.target.parentElement.children].forEach(sib => sib.classList.remove('visible'));
    } else {
        [...event.target.parentElement.children].forEach(sib => sib.classList.remove('active'));
        event.target.classList.add('active');
        [...myElem.parentElement.children].forEach(sib => sib.classList.remove('visible'));
        myElem.classList.add('visible');
    }
}

const btns = document.querySelectorAll('.megamenu summary');
[...btns].forEach(btn =>{
    btn.addEventListener('click', (e) => {
    e.stopPropagation();
    let url = btn.getAttribute('data-url');
    window.location.href = url;
    // alert('The button was clicked!'+url);
});
});


// Product description
function showMore(event, long_des, short_des) {
    // console.log(event.currentTarget);
    document.querySelector('.' + long_des).classList.remove("hide");
    document.querySelector('.' + short_des).classList.add("hide");
    event.currentTarget.classList.add("hide");
    event.currentTarget.nextElementSibling.classList.remove("hide");
    // console.log(`${long_des}`);
}
function showLess(event, long_des, short_des) {
    document.querySelector('.' + long_des).classList.add("hide");
    document.querySelector('.' + short_des).classList.remove("hide");
    event.currentTarget.classList.add("hide");
    event.currentTarget.previousElementSibling.classList.remove("hide");
    // console.log(`${short_des}`);
}


// cart
if (document.body.classList.contains("active")) {
    let elem = document.querySelector('cart-items');
    let rect = elem.getBoundingClientRect();
    document.querySelector('.cart__footer .cart__blocks').style.top = `${rect.y + 86 + 30.812}px`;
    // console.log("x: " + rect.x);
    // console.log("y: " + rect.y);
}


// breadcrumb
if (document.body.classList.contains("collection")) {
    var collection_title = document.querySelector("#ProductGridContainer").getAttribute('title');
    var collection_url = document.querySelector("#ProductGridContainer").getAttribute('url');
    var collection = { "template": document.body.getAttribute('template-name'), "name": collection_title, "url": collection_url };
    localStorage.setItem('breadcrumbCollection', JSON.stringify(collection));
}
var breadcrumbObject = JSON.parse(localStorage.getItem('breadcrumbCollection'));
var previousBreadcrumbCollectionObje = JSON.parse(localStorage.getItem('previousBreadcrumbCollection'));
// console.log(breadcrumbObject);
if (document.body.classList.contains("product")) {
    if (breadcrumbObject != null) {
        if (breadcrumbObject.template == "collection") {
            var breadcrumbCol = document.getElementById('collection-breadcrumb');
            if ($.inArray(breadcrumbObject.name, currentCollectionTitle) != -1) {
                // console.log(currentCollectionTitle);
                breadcrumbCol.text = breadcrumbObject.name;
                breadcrumbCol.setAttribute("href", breadcrumbObject.url);
                document.querySelector(".hide_collection_breadcrumb").style.display = "inline-block";
            } else {
                // console.log("notfound");
                document.querySelector(".hide_collection_breadcrumb").style.display = "none";
            }

        }
    }
}

// Account toggle
function toggleFunction(event) {
    // console.log(event.currentTarget);
    event.currentTarget.classList.toggle("active");
    document.querySelector(".customer-dropdown").classList.toggle("active");
}


//   product qty sel
// console.log(max_qty);

var myElem = document.querySelector('.product-form__submit');
if (myElem === null){
}else{
  var productId = myElem.getAttribute('data-product_id');
}



if(max_qty != 'not-found'){
setInterval(function () {
    let currentVariantId = document.querySelector('product-form.product-form').getAttribute('current_var');
    let selected_product_qty = document.querySelector('product-form.product-form').getAttribute('current_var_qty');
    let max_product_qty = max_qty;
    let max_qty_reach_flag = false;
    let cartitemQty = 0;
    var needcartitemQty = 0;
    if (max_product_qty >= selected_product_qty){
    max_product_qty = selected_product_qty;
    }
    fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(data => { 
      if( data.items.length > 0 ){
        let prod_id_qty_obj = {};
        data.items.forEach(item => {
        // console.log('check = '+typeof prod_id_qty_obj[item.product_id]);
          if (typeof prod_id_qty_obj[item.product_id] != 'undefined') {
            // console.log('if');
              prod_id_qty_obj[item.product_id] += item.quantity
          } else {
            // console.log('else');
              prod_id_qty_obj[item.product_id] = item.quantity;
          }
          let objectArray = Object.entries(prod_id_qty_obj);
          // console.log(productId);
          objectArray.forEach((item)=>{
            if(parseInt(item[0])==parseInt(productId)){
              // console.log(parseInt(item[1])+'= max-qty = '+ max_qty);
                document.querySelector('#product_'+item[0]+' .quantity__input').setAttribute('max',max_qty - parseInt(item[1]));   

            if (max_product_qty <= parseInt(item[1])) {
              // console.log('if');
              document.querySelector('#buttons_'+productId).classList.add('exceed');
              document.querySelector('#buttons_'+productId).classList.remove('not-exceed');
            } else {
              // console.log('else');
              document.querySelector('#buttons_'+productId).classList.add('not-exceed');
              document.querySelector('#buttons_'+productId).classList.remove('exceed');
            }

            }
          })

        // previous code
        // currentVariantId =  Number(currentVariantId);
        // if(currentVariantId == Number(item.variant_id)){
        //   if(Number(item.quantity) == Number(max_product_qty)){
        //     max_qty_reach_flag = true;
        //     needcartitemQty = max_product_qty;
        //     document.querySelector('.product-form.customFormClass').classList.add('disabled');
        //   }else{
        //     max_qty_reach_flag = false;
        //     needcartitemQty = (max_product_qty - item.quantity);
        //     document.querySelector('.needto').innerHTML= needcartitemQty;
        //     document.querySelector('.custom-quantity__input').setAttribute("max", needcartitemQty);
        //     document.querySelector('.product-form.customFormClass').classList.remove('disabled');
        //   }
        //   cartitemQty = item.quantity
        // }
      });
    }else{
      document.querySelector('.product-form.customFormClass').classList.remove('disabled');
      document.querySelector('.custom-quantity__input').setAttribute("max", max_product_qty);
      document.querySelector('.needto').innerHTML= max_product_qty;
    }
    });
}, 1000);
}



// product page color var


function getOption(selectObject) {
    var value = selectObject.value;  
    console.log(`[liniktoid="${value.toLowerCase().replace(/_|-/g, '')}"]`);
    let el = document.querySelector(`[liniktoid="${value.toLowerCase().replace(/_|-/g, '')}"]`);
        [...el.parentElement.children].forEach(sib => sib.removeAttribute('checked'));
        el.setAttribute('checked', 'checked');
        // el.click();
  }




  // Article page
// copy link
  function copyToClipboard(text) {
    var inputc = document.body.appendChild(document.createElement("input"));
    inputc.value = window.location.href;
    inputc.focus();
    inputc.select();
    document.execCommand('copy');
    inputc.parentNode.removeChild(inputc);
    console.log("URL Copied.");
    var $this = document.querySelector('.clipboard_copy');
    if ($this.innerText=="Copy Link") $this.innerText = "Copied Link";
    else $this.innerText = "Copy Link";
    }



if(document.querySelector(".hulk__wishlist-wrap")){
    document.body.addEventListener("click",(e) => {
    const btn = document.querySelectorAll("[data-hulkappsmoveitemsok]");
    btn.forEach(addBtn =>{
      if(e.target == addBtn){
        //console.log("if working");
        setTimeout(function() {
         fetch(`${window.routes.cart_url}.js`).then(async (response2) => {
            const cartContent = await response2.json();
            if((typeof Shopify) === 'undefined'){ window.Shopify = {}; }
            if((typeof Shopify.getCart) === 'undefined'){
              Shopify.getCart = function(callback, cart){
                if(!cart){
                  return jQuery.getJSON('/cart.js', function(cart, textStatus, xhr){
                    if((typeof callback) === 'function'){
                      callback(cart, textStatus, xhr);
                    } else {
                      Shopify.onCartUpdate(cart);
                    }
                  });
                } else {
                  if((typeof callback) === 'function'){
                    callback(cart);
                  } else if(typeof Shopify.onCartUpdate === 'function'){
                    Shopify.onCartUpdate(cart);
                  }
                }
              };
            }
            Shopify.getCart(function(cart){
              fetch('/?sections=cart-drawer')
                      .then((response) => response.json())
                      .then((data) => {
                          //console.log(data);
                          let SectionHtml = data['cart-drawer'];
                          document.getElementById("temp_cart").innerHTML = SectionHtml;
                          let IDminiCart = document.querySelector("#temp_cart #CartDrawer");
                          let drwIDminiCart = document.querySelector("cart-drawer #CartDrawer");
                          drwIDminiCart.innerHTML = IDminiCart.innerHTML;
                          document.querySelector("cart-drawer").classList.add('animate', 'active');
                          if (document.querySelector("cart-drawer").classList.contains('is-empty'))
                              document.querySelector("cart-drawer").classList.remove('is-empty')
                      });
                  fetch('/cart.js')
                      .then((response) => response.json())
                      .then((cart) => {
                          var count = cart.item_count;
                          if(document.querySelector(".cart-count-bubble") == null ){
                              document.querySelector("#cart-icon-bubble .small-hide.medium-hide").insertAdjacentHTML('afterEnd', `<div class="cart-count-bubble"><span aria-hidden="true">${count}</span><span class="visually-hidden">${count} items</span></div>`)
                          }else{
                              document.querySelector(".cart-count-bubble").innerHTML = `<span aria-hidden="true">${count}</span><span class="visually-hidden">${count} items</span>`;
                          }
                          
                      });
            
            }.bind(this));
        });
        },5000);
      }
    });
  });
}





// review
setTimeout(() => {
  console.log("Delayed for 1 second.");
//  let htmlText = document.querySelector(".js-oke-widgetSize").innerHTML();
//console.log(htmlText);
  const box = document.querySelector(".js-oke-widgetSize");
  console.log(box.childNodes);
  if (box.childNodes.length <= 1) {
    document.querySelector(".review_section").classList.add('hide');
    document.querySelector(".review_title").classList.add('hide');
    console.log('✅ Element is empty');
  } else {
    console.log('⛔️ Element is NOT empty');
    document.querySelector(".review_section").classList.remove('hide');
    document.querySelector(".review_title").classList.remove('hide');

  }
}, "1000");
